__turbopack_context__.v({
  "closeButton": "FeaturedHeroVideo-module-scss-module__F_151W__closeButton",
  "modal": "FeaturedHeroVideo-module-scss-module__F_151W__modal",
  "modalContainer": "FeaturedHeroVideo-module-scss-module__F_151W__modalContainer",
  "modalVideoWrapper": "FeaturedHeroVideo-module-scss-module__F_151W__modalVideoWrapper",
  "overlay": "FeaturedHeroVideo-module-scss-module__F_151W__overlay",
  "playButton": "FeaturedHeroVideo-module-scss-module__F_151W__playButton",
  "playButtonIcon": "FeaturedHeroVideo-module-scss-module__F_151W__playButtonIcon",
  "root": "FeaturedHeroVideo-module-scss-module__F_151W__root",
});
